import { getIntegral,getExchange } from '@this/services/integral';
import { Toast } from 'vant';
const state = {
  integralPopup: false,
  integraList:[]
};

const mutations = {
  setIntegraList(state, list) {
    state.integraList = list;
  },
   setIntegralPopup(state, bool) {
    state.integralPopup = bool;
  },
};

const actions = {
  getIntegral({ commit , dispatch}) {
    getIntegral().then((res) => {
      commit('setIntegraList', res.data);
      dispatch('changeIntegralPopup')
    });
  },
  changeIntegralPopup({ commit, state }, bool) {
    const integralPopup = bool ?? !state.integralPopup;
    commit('setIntegralPopup', integralPopup);
  },
  clickExchange({ dispatch,rootState },item){
    const {
      user: { userInfo },
    } = rootState;
    if(userInfo.integral<item.integral){
      Toast('积分不足！');
      return
    }
    dispatch('getExchange',item)
  },
  getExchange({rootState},item){
    getExchange({exchange_id:item.id}).then((res) => {
      if(!res.code){
        const {
          user: { userInfo },
        } = rootState;
     userInfo.integral-=item.integral
        item.status='1'
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
